import React from 'react';
import { CircularProgress, Box } from '@mui/material';

const LoadingFallback = () => (
    <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="60vh"
        sx={{ py: 4 }}
    >
        <CircularProgress size={48} />
    </Box>
);

export default LoadingFallback;
